var map = {
	"./M_Maximiza.png": 93081,
	"./M_Maximiza_blanco.png": 66515,
	"./M_Maximiza_negro.png": 72719,
	"./logo-aniversario-2.png": 95809,
	"./logo-aniversario.png": 18612,
	"./logo-halloween.png": 25764,
	"./logo-mujer.png": 53428,
	"./logo.png": 36918,
	"./logoHQ.png": 43983,
	"./mxz_ticket.png": 25973,
	"./mxz_ticket_navidad.png": 97563,
	"./mxz_ticket_septiembre_blanco.png": 16702,
	"./ticket-navidad.png": 767,
	"./ticket-septiembre.png": 22670
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95379;